import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SingleSelect from '../../../input_filed/SingleSelect';
import SaveButton from '../../../buttons/SaveButton';
import { useFormik } from 'formik';
import { toast, ToastContainer } from 'react-toastify';
import { Form } from 'react-bootstrap';
import Text from '../../../input_filed/Text';
import { defectSchema } from './ValidationSchema';
import { addDefectTodo } from '../../../../redux/slices/master/defects/AddDefect';

export default function AddDefectForm() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [spiner, setSpiner] = useState(false)

    const status_option = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    const category_option = [
        { value: 'critical', label: 'Critical' },
        { value: 'noncritical', label: 'Noncritical' },
        { value: 'erasable', label: 'Erasable' },
    ];

    const remark_option = [
        { value: 'acceptable', label: 'Acceptable' },
        { value: 'unacceptable', label: 'Unacceptable' },
        { value: 'review', label: 'Review' },
        { value: 'erasable', label: 'Erasable' },
    ];

    const initiaValues = {
        defect: '',
        category: '',
        remark: '',
        status: '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: defectSchema,

        onSubmit: (values, action) => {
            setSpiner(true)
            dispatch(addDefectTodo(values)).then((res) => add_res(res))
        }
    })

    const add_res = (res) => {
        // if (res?.status) {
        //     setSpiner(false);
        //     toast.success(res?.message, { position: "bottom-right" });
        //     setTimeout(() => {
        //         setSpiner(false);
        //         navigate('/defect-list')
        //     }, 1000);
        // } else {
        //     setSpiner(false);
        //     toast.error(res?.message, { position: "bottom-right" });
        // }

        if (res?.payload?.status == 201) {
            toast.success(res?.payload?.data?.message, { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/defect-list')
            }, 1000);
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
            setSpiner(false);
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }
    return (
        <>

            <Form onSubmit={handleSubmit}>
                <div className='main_layout'>
                    <div className='layout_head mb-3'>
                        <h5>Add Defect</h5>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-3'>
                            <Text
                                label_name='Defects'
                                name='defect'
                                value={values.defect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.defect && touched.defect && <span className='text-danger form_label'>{errors.defect}</span>}
                            />
                        </div>
                        <div className='col-md-3'>
                            <SingleSelect
                                label_name='Category'
                                option={category_option}
                                name='category'
                                onChange={(e) => setFieldValue('category', e.value)}
                                onBlur={handleBlur}
                                error={errors.category && touched.category && <span className='text-danger form_label'>{errors.category}</span>}
                            />
                        </div>
                        <div className='col-md-3'>
                            <SingleSelect
                                label_name='Remark'
                                option={remark_option}
                                name='remark'
                                onChange={(e) => setFieldValue('remark', e.value)}
                                onBlur={handleBlur}
                                error={errors.remark && touched.remark && <span className='text-danger form_label'>{errors.remark}</span>}
                            />
                        </div>
                        <div className='col-md-3'>
                            <SingleSelect
                                label_name='Status'
                                option={status_option}
                                name='status'
                                onChange={(e) => setFieldValue('status', e.value)}
                                onBlur={handleBlur}
                                error={errors.status && touched.status && <span className='text-danger form_label'>{errors.status}</span>}
                            />
                        </div>
                        <div className='col-md-12 text-end mt-4 pt-2'>
                            <SaveButton name={'SAVE'} spiner={spiner} />
                        </div>
                    </div>
                </div>
            </Form>
        </>
    )
}
